import Duration from "~/components/shared/Duration";
import { getDuration } from "~/lib/date";
import { jobTime } from "~/lib/jobs";
import { Job } from "~/components/build/Show/lib/types";
import { SortFn } from ".";
import Icon from "~/components/shared/Icon";

const getJobDuration = (job: Job) => {
  const { from, to } = jobTime({ ...job, state: job.state.toUpperCase() });
  return getDuration(from, to).asSeconds();
};

export function RunDuration({ job }: { job: Job }) {
  if (job.type !== "script" && job.type !== "trigger") {
    return null;
  }

  if (!job.startedAt) {
    return null;
  }

  const timestamps = jobTime({ ...job, state: job.state.toUpperCase() });

  return (
    <div className="flex items-center gap-1">
      <Icon icon="custom/outline/timer" className="block h-4 w-4 text-gray-800" />
      <Duration.Short {...timestamps} />
    </div>
  );
}

// eslint-disable-next-line id-length
export const sortByRunDuration: SortFn = (direction) => (a, b) => {
  const aDuration = getJobDuration(a);
  const bDuration = getJobDuration(b);

  if (aDuration === bDuration) {
    return 0;
  }

  if (direction === "asc") {
    return aDuration > bDuration ? 1 : -1;
  }

  return aDuration > bDuration ? -1 : 1;
};
